module.exports = __webpack_public_path__ + "static/media/aus_feb_2025.f06b89bc.webp";